import { render, staticRenderFns } from "./vote.vue?vue&type=template&id=2fe4ecd0&scoped=true"
import script from "./vote.vue?vue&type=script&lang=js"
export * from "./vote.vue?vue&type=script&lang=js"
import style0 from "./vote.vue?vue&type=style&index=0&id=2fe4ecd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe4ecd0",
  null
  
)

export default component.exports